function rushFeeParseSectionHtml(html, selector) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  if (selector) {
    const node = doc.querySelector(selector);
    return node ? node.innerHTML : '';
  }
  return doc.querySelector('.shopify-section')?.innerHTML || '';
}

function rushFeeCollectSections() {
  const sections = [];
  const seen = new Set();

  const cartDrawer = document.querySelector('cart-drawer');
  const drawerIsActive = cartDrawer?.classList.contains('active');
  const sources = [];

  if (drawerIsActive) {
    sources.push(document.querySelector('cart-drawer-items'));
  }

  sources.push(document.querySelector('cart-items'), document.querySelector('cart-drawer-items'));

  sources.forEach((element) => {
    if (!element?.getSectionsToRender) return;

    element.getSectionsToRender().forEach((config) => {
      const key = `${config.section || config.id}:${config.selector || ''}`;
      if (seen.has(key)) return;
      seen.add(key);
      sections.push(config);
    });
  });

  return sections;
}

function rushFeeGetActiveCartContext() {
  const sections = rushFeeCollectSections();
  const handler =
    (document.querySelector('cart-drawer')?.classList.contains('active') &&
      document.querySelector('cart-drawer-items')) ||
    document.querySelector('cart-items') ||
    document.querySelector('cart-drawer-items');

  return { handler, sections };
}

function rushFeeRenderSections(parsedState, sections) {
  if (!parsedState?.sections || !sections?.length) return false;

  let updated = false;

  sections.forEach((config) => {
    const sectionHtml = parsedState.sections[config.section];
    if (!sectionHtml) return;

    const target =
      document.getElementById(config.id)?.querySelector(config.selector) ||
      document.getElementById(config.id);

    if (!target) return;

    target.innerHTML = rushFeeParseSectionHtml(sectionHtml, config.selector);
    updated = true;
  });

  return updated;
}

function rushFeeFallbackRefresh() {
  const cartItems = document.querySelector('cart-items');
  if (cartItems?.onCartUpdate) {
    return cartItems.onCartUpdate();
  }

  const cartDrawerItems = document.querySelector('cart-drawer-items');
  if (cartDrawerItems?.onCartUpdate) {
    return cartDrawerItems.onCartUpdate();
  }

  return Promise.resolve();
}

function rushFeeSyncCartPageLayout(isEmpty) {
  const cartPageWrapper = document.querySelector('.is-cart-page');
  const footerSection = document.querySelector('.shopify-section.cart__footer-wrapper');

  if (cartPageWrapper) cartPageWrapper.classList.toggle('is-cart-empty', isEmpty);
  if (footerSection) footerSection.classList.toggle('cart-footer-hidden', isEmpty);
}

function rushFeeSyncEmptyState(itemCount) {
  const isEmpty = itemCount === 0;

  document.querySelector('cart-items')?.classList.toggle('is-empty', isEmpty);
  document.querySelector('cart-drawer-items')?.classList.toggle('is-empty', isEmpty);
  document.getElementById('main-cart-footer')?.classList.toggle('is-empty', isEmpty);
  document.querySelector('cart-drawer')?.classList.toggle('is-empty', isEmpty);
  rushFeeSyncCartPageLayout(isEmpty);
}

window.rushFeeSyncCartPageLayout = rushFeeSyncCartPageLayout;
window.rushFeeSyncEmptyState = rushFeeSyncEmptyState;

function rushFeePublishCartUpdate(cartData, variantId) {
  if (typeof publish !== 'function') return;

  publish(PUB_SUB_EVENTS.cartUpdate, {
    source: 'rush-fee',
    cartData,
    productVariantId: variantId,
  });
}

function rushFeeApplyCartResponse(parsedState, sections, variantId) {
  const rendered = rushFeeRenderSections(parsedState, sections);

  if (!rendered) {
    return rushFeeFallbackRefresh();
  }

  return Promise.resolve();
}

function rushFeeIsRushLine(item, config) {
  if (!item || !config) return false;

  const variantId = String(config.variantId || '').trim();
  const handle = String(config.productHandle || '').trim();

  if (variantId && String(item.variant_id) === variantId) return true;
  if (handle && item.handle === handle) return true;

  return false;
}

function rushFeeGetDisplayItemCount(cartData) {
  const config = window.rushFeeConfig;
  const items = cartData?.items || [];

  if (!config?.enabled) {
    return cartData?.item_count ?? items.reduce((total, item) => total + (item.quantity || 0), 0);
  }

  return items.reduce((total, item) => {
    if (rushFeeIsRushLine(item, config)) return total;
    return total + (item.quantity || 0);
  }, 0);
}

function rushFeeUpdateCartBubbleCount(cartData) {
  const displayCount = rushFeeGetDisplayItemCount(cartData);
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (!cartIcon) return;

  let bubble = cartIcon.querySelector('.cart-count-bubble');

  if (displayCount <= 0) {
    bubble?.remove();
    return;
  }

  if (!bubble) {
    bubble = document.createElement('div');
    bubble.className = 'cart-count-bubble';
    cartIcon.appendChild(bubble);
  }

  const countLabel =
    displayCount === 1 ? `${displayCount} item` : `${displayCount} items`;

  bubble.innerHTML =
    displayCount < 100
      ? `<span aria-hidden="true">${displayCount}</span><span class="visually-hidden">${countLabel}</span>`
      : `<span class="visually-hidden">${countLabel}</span>`;
}

window.rushFeeGetDisplayItemCount = rushFeeGetDisplayItemCount;
window.rushFeeUpdateCartBubbleCount = rushFeeUpdateCartBubbleCount;

let rushFeeOrphanCleanupRunning = false;

async function rushFeeRemoveIfOrphaned(cartData, options = {}) {
  const { skipRender = false, skipPublish = false, sections: sectionsOverride = null } = options;
  const config = window.rushFeeConfig;
  if (!config?.enabled || rushFeeOrphanCleanupRunning) {
    return cartData;
  }

  const variantId = String(config.variantId || '').trim();
  const productHandle = String(config.productHandle || '').trim();
  if (!variantId && !productHandle) {
    return cartData;
  }

  const items = cartData?.items || [];
  const rushItems = items.filter((item) => rushFeeIsRushLine(item, config));
  const regularCount = items.length - rushItems.length;

  if (rushItems.length === 0 || regularCount > 0) {
    return cartData;
  }

  rushFeeOrphanCleanupRunning = true;

  try {
    const sections = sectionsOverride?.length ? sectionsOverride : rushFeeCollectSections();
    const body = {
      quantity: 0,
    };

    if (variantId) {
      body.id = variantId;
    } else {
      const rushIndex = items.findIndex((item) => rushFeeIsRushLine(item, config));
      body.line = rushIndex >= 0 ? rushIndex + 1 : 1;
    }

    const sectionKeys = sections.map((entry) => entry.section).filter(Boolean);
    if (sectionKeys.length) {
      body.sections = sectionKeys.join(',');
      body.sections_url = window.location.pathname;
    }

    const response = await fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body: JSON.stringify(body),
    });
    const parsedState = JSON.parse(await response.text());

    if (parsedState.errors) {
      throw new Error(parsedState.errors);
    }

    if (!skipRender) {
      rushFeeSyncEmptyState(parsedState.item_count);
      rushFeeUpdateCartBubbleCount(parsedState);

      const applied = rushFeeRenderSections(parsedState, sections);
      if (!applied) {
        await rushFeeFallbackRefresh();
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', { detail: parsedState, bubbles: true })
      );
    }

    if (!skipPublish && typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'rush-fee',
        cartData: parsedState,
        productVariantId: variantId || config.variantId,
      });
    }

    return parsedState;
  } catch (error) {
    console.error('Rush fee orphan cleanup failed:', error);
    return cartData;
  } finally {
    rushFeeOrphanCleanupRunning = false;
  }
}

window.rushFeeRemoveIfOrphaned = rushFeeRemoveIfOrphaned;

async function rushFeeHandleCartChange(event) {
  if (!window.rushFeeConfig?.enabled || event?.source === 'rush-fee') return;

  let cartData = event?.cartData;
  if (!cartData?.items) {
    try {
      cartData = await fetch('/cart.js').then((response) => response.json());
    } catch (error) {
      console.error(error);
      return;
    }
  }

  const updatedCart = await rushFeeRemoveIfOrphaned(cartData);
  rushFeeUpdateCartBubbleCount(updatedCart);
}

if (
  !window.__rushFeeCartListenerRegistered &&
  typeof subscribe === 'function' &&
  typeof PUB_SUB_EVENTS !== 'undefined'
) {
  window.__rushFeeCartListenerRegistered = true;
  subscribe(PUB_SUB_EVENTS.cartUpdate, rushFeeHandleCartChange);
}

class RushFeeAddButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', this.onClick.bind(this));
  }

  setLoading(isLoading) {
    const spinner = this.button.querySelector('.loading__spinner');
    const label = this.button.querySelector('.cart-rush-processing__button-label');

    if (isLoading) {
      this.button.setAttribute('aria-disabled', 'true');
      this.button.classList.add('loading');
      spinner?.classList.remove('hidden');
      label?.classList.add('hidden');
    } else {
      this.button.removeAttribute('aria-disabled');
      this.button.classList.remove('loading');
      spinner?.classList.add('hidden');
      label?.classList.remove('hidden');
    }
  }

  onClick(event) {
    event.preventDefault();
    const variantId = this.dataset.variantId;
    if (!variantId || this.button.getAttribute('aria-disabled') === 'true') return;

    const { sections } = rushFeeGetActiveCartContext();
    const sectionKeys = sections.map((entry) => entry.section).filter(Boolean);

    const body = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
    };

    if (sectionKeys.length) {
      body.sections = sectionKeys.join(',');
      body.sections_url = window.location.pathname;
    }

    this.setLoading(true);

    const addUrl = window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.description || response.message || 'Could not add rush fee');
        }

        rushFeeSyncEmptyState(response.item_count);
        rushFeeUpdateCartBubbleCount(response);

        return rushFeeApplyCartResponse(response, sections, variantId).then(() => {
          rushFeePublishCartUpdate(response, variantId);
        });
      })
      .catch((error) => {
        console.error(error);
        const errors = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
        if (errors) {
          errors.textContent = error.message || 'Unable to add rush processing fee. Please try again.';
        }
      })
      .finally(() => {
        this.setLoading(false);
      });
  }
}

if (!customElements.get('rush-fee-add-button')) {
  customElements.define('rush-fee-add-button', RushFeeAddButton);
}

class RushFeeRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.addEventListener('click', this.onClick.bind(this));
  }

  setLoading(isLoading) {
    if (!this.button) return;

    if (isLoading) {
      this.button.setAttribute('aria-disabled', 'true');
      this.button.classList.add('loading');
    } else {
      this.button.removeAttribute('aria-disabled');
      this.button.classList.remove('loading');
    }
  }

  onClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const variantId = this.dataset.variantId;
    if (!variantId || this.button?.getAttribute('aria-disabled') === 'true') return;

    const { sections } = rushFeeGetActiveCartContext();
    const sectionKeys = sections.map((entry) => entry.section).filter(Boolean);

    const body = {
      id: variantId,
      quantity: 0,
    };

    if (sectionKeys.length) {
      body.sections = sectionKeys.join(',');
      body.sections_url = window.location.pathname;
    }

    this.setLoading(true);

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          throw new Error(parsedState.errors);
        }

        rushFeeSyncEmptyState(parsedState.item_count);
        rushFeeUpdateCartBubbleCount(parsedState);

        return rushFeeApplyCartResponse(parsedState, sections, variantId).then(() => {
          rushFeePublishCartUpdate(parsedState, variantId);
        });
      })
      .catch((error) => {
        console.error(error);
        const errors = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
        if (errors) {
          errors.textContent =
            typeof error === 'string' ? error : error.message || 'Unable to remove rush processing fee.';
        }
      })
      .finally(() => {
        this.setLoading(false);
      });
  }
}

if (!customElements.get('rush-fee-remove-button')) {
  customElements.define('rush-fee-remove-button', RushFeeRemoveButton);
}
